import { render, staticRenderFns } from "./BillsTable.vue?vue&type=template&id=f35c12b0&scoped=true&"
import script from "./BillsTable.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BillsTable.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35c12b0",
  null
  
)

export default component.exports